import { createSelector } from 'reselect'

const getAdminOnboardingData = state => state.adminOnboarding

export default createSelector(
	[ getAdminOnboardingData ],
	adminOnboarding => adminOnboarding.durationDays
)
